import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";
import { getCurrentCulture } from "@utils";
import { redirect } from "@state";
import { useRootAppStore } from "@hooks";
import { ChatViewStore } from "@state/stores/chat/ChatViewStore";
import { Button } from "@components/buttons";

export default observer(function SupportChatInfoBox({
	store,
}: {
	store: ChatViewStore;
}) {
	const { t } = useTranslation();
	const { userAuthStore } = useRootAppStore();

	const dismiss = async () => {
		if (userAuthStore.user?.username && userAuthStore.user?.chatName) {
			await store.updateSupportChatLinkStatus(
				userAuthStore.user.username
			);
		}

		store.setIsSupportChatLinkDismissed(true);
	};

	if (store.isSupportChatLinkBoxDismissed) {
		return null;
	}

	return (
		<div className="message message--note message--sml">
			<div className="message__content">
				<div className="message__header">
					<div className="message__title message__title--grow u-type--base">
						Info
					</div>
					<Button
						type="button"
						className="btn--square btn--square--xsml btn--ghost"
						iconOnly
						iconClassName="u-icon--tny u-icon--close"
						onClick={dismiss}
					/>
				</div>
				<ReactMarkdown className="u-anchor--nested">
					{t("CHAT.SUPPORT_CHAT_LINK_INFO")}
				</ReactMarkdown>
				<Button
					type="button"
					onClick={() => {
						redirect(`/${getCurrentCulture()}/support-chat`);
					}}
					className="message__btn btn--sml btn--block btn--primary--inverted btn--icon"
					btnContent={
						<>
							<i className="u-icon u-icon--sml u-icon--support--alt" />
							{t("CHAT.SUPPORT.TITLE")}
							<i className="u-icon u-icon--tny u-icon--arrow-right" />
						</>
					}
				/>
			</div>
		</div>
	);
});
